const isProxy = import.meta.env.MODE === 'proxy';
const tld = isProxy ? 'test' : 'nl';

const apiBase = isProxy
  ? new URL(import.meta.env.VITE_API_BASE_URL).hostname
  : 'api.mijnafinius.nl';

const domains = [
  `overzicht.cityview.${tld}`,
  `doeeenmelding.${tld}`,
  `sensorregister.${tld}`,
  `cityview.${tld}`,
  `auth.mijnafinius.${tld}`,
  `mijnafinius.${tld}`,
  `mijnnodr.${tld}`,
];

const baseUrl = ((): string => {
  const { hostname, port, origin, protocol } = location;

  const isLocalhost = hostname === 'localhost' || /^192.168.*$/.test(hostname);

  if (isLocalhost) {
    if (!port || protocol === 'capacitor:') {
      return import.meta.env.VITE_API_BASE_URL;
    }

    if (port === '8080' || port === '8084' || port === '8087') {
      return import.meta.env.VITE_API_BASE_URL;
    }

    return import.meta.env.VITE_API_TENANT_BASE_URL;
  }

  for (const domain of domains) {
    if (hostname.endsWith(domain)) {
      return origin.replace(domain, apiBase);
    }
  }

  return origin;
})();

export const generateUrl = (path?: string): string => {
  const strippedPath = path?.replace(/^\/+/, '');
  return [baseUrl, strippedPath].filter(Boolean).join('/');
};
